(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["route-collection-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rt-more]');
    if (!button) return;
    button.previousElementSibling?.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["route-format-cards"] && !Shopify.designMode) return;
  try {
    
  class RouteKcCard extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-set]');
        if (!button) return;
        this.dataset[button.dataset.set] = button.dataset.value;
        this.querySelectorAll(`[data-set="${button.dataset.set}"]`).forEach((b) =>
          b.setAttribute('aria-pressed', String(b === button))
        );
        const combo = `${this.dataset.body}-${this.dataset.route}`;
        this.querySelectorAll('[data-combo]').forEach((img) => {
          img.loading = 'eager';
          img.classList.toggle('is-active', img.dataset.combo === combo);
        });
      });
    }
  }

  if (!customElements.get('route-kc-card')) customElements.define('route-kc-card', RouteKcCard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["route-keychain-colors"] && !Shopify.designMode) return;
  try {
    
  class RouteKcPicker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-set]');
        if (!button) return;
        this.dataset[button.dataset.set] = button.dataset.value;
        this.querySelectorAll(`[data-set="${button.dataset.set}"]`).forEach((b) =>
          b.setAttribute('aria-pressed', String(b === button))
        );
        this.sync();
      });
      this.sync();
    }

    sync() {
      const combo = `${this.dataset.body}-${this.dataset.route}`;
      this.querySelectorAll('[data-combo]').forEach((pic) => pic.classList.toggle('is-active', pic.dataset.combo === combo));
    }
  }

  if (!customElements.get('route-kc-picker')) customElements.define('route-kc-picker', RouteKcPicker);

  } catch(e) { console.error(e); }
})();
})();
